import { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";

const CookieBanner = () => {
  const [accepted, setAccepted] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    const isCookieAccepted = localStorage.getItem("cookieAccepted");
    if (isCookieAccepted) {
      setAccepted(true);
    }
  }, []);

  const handleAccept = () => {
    setAccepted(true);
    localStorage.setItem("cookieAccepted", "true");
  };

  if (accepted) {
    return null;
  }

  return (
    <div className="sticky bottom-0 bg-[#fff] shadow-lg p-3 ">
      <div className="flex justify-center items-center gap-5 text-[14px] flex-col lg:flex-row">
        <div>{t("cookieText")}</div>
        <button
          onClick={handleAccept}
          className="rounded-md bg-[#FF5744] px-3 py-2 text-[14px] font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 max-w-[300px]"
        >
          {t("accept")}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
